const NAMESPACE = "energystorage";

const KEYS = {
    addIntegratedEnergyStorageButtonText: "addIntegratedEnergyStorageButtonText",
    addInverterAndBatteryButtonText: "addInverterAndBatteryButtonText",
    needsRecalculatedMessage: "needsRecalculatedMessage",
    notYetCalculatedMessage: "notCalculatedMessage",
    calculateButtonText: "calculateButtonText",
    energyCalculationDisplayName: "energyCalculationDisplayName",
    powerCalculationDisplayName: "powerCalculationDisplayName"
};

const MESSAGES = {
    [KEYS.addIntegratedEnergyStorageButtonText]: {
        value: "Add Integrated Energy Storage",
        comment: "Label for button which creates a new integrated energy storage subsystem"
    },
    [KEYS.addInverterAndBatteryButtonText]: {
        value: "Add Inverter and Battery",
        comment: "Label for button which creates a new inverter+battery subsystem"
    },
    [KEYS.needsRecalculatedMessage]: {
        value: "Needs to be recalculated",
        comment: "Message for communicating that the output values need to be recalculated in light of new input"
    },
    [KEYS.notYetCalculatedMessage]: {
        value: "Not yet calculated",
        comment: "Message for communicating that the output data has not yet been calculated"
    },
    [KEYS.calculateButtonText]: {
        value: "Calculate",
        comment: "Label for button which runs calculations"
    },
    [KEYS.energyCalculationDisplayName]: {
        value: "Total Nameplate Energy Capacity (Storage)",
        comment: "Label for energy calculation result"
    },
    [KEYS.powerCalculationDisplayName]: {
        value: "Total Max. Continuous Discharge Rate",
        comment: "Label for power calculation result"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
